import React from "react";
import styles from "./SuccessPage.module.css";
import logo from "../../assets/images/logo.png";
import successimg from "../../assets/images/successimg.png";
import Footer from "../../components/Footer/Footer";
import { NavLink } from "react-router-dom";
import Confetti from "react-confetti";

const SuccessPage = () => {
  return (
    <>
      <div className={styles.successpage}>

        <div className={styles.main_container}>
          <div className={styles.head_section}>
            <div className={styles.logo}>
              <img src={logo} alt="" />
              <p>Musicart</p>
            </div>
          </div>

          <div className={styles.container}>
            <img src={successimg} alt="successimg" />
            <div className={styles.msg}>
              <span className={styles.success_msg}>
                Order is placed successfully!
              </span>
              <span className={styles.confirm_msg}>
                You will be receiving a confirmation email with order details
              </span>
            </div>
            <button className={styles.back_btn}>
              <NavLink className={styles.link_back_btn} to="/home">Go back to Home page </NavLink>
            </button>
          </div>
        </div>
        <Footer />
        <Confetti />

      </div>
    </>
  );
};

export default SuccessPage;
